import React, { useEffect, useState } from "react";
import { Grid, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import { useSelector } from "react-redux";

export const Alert = ({ ico }) => {
  const { afiliadoEncontrado } = useSelector((state) => state.preinscripto)
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (afiliadoEncontrado.estado === 1) {
      setOpen(true);
    } else {
      setOpen(false);
    }
    // eslint-disable-next-line
  }, [])
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid container justify="center">
            <img src={ico} alt="icono de estado de circulación" />
          </Grid>
        </DialogTitle>
        <Grid container justify="center">
          <Typography>{afiliadoEncontrado?.apellido_y_nombre}</Typography>
        </Grid>
        <DialogContent>
          <Grid container justify="center">
            <Typography>Existe un Email sin validar</Typography>
            <Typography>Favor de verificar casilla informada y revisar en su correo electronico</Typography>
            <Typography><strong>En el caso que desee modificar algun dato puede hacerlo.</strong> </Typography>

          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container justify="center">
            <Button onClick={handleClose} color="primary">
              OK
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  )
};
